const testSets = {
  valuePairSets: [
    { which: 1,
      valueSet: [
        ["B1", "B101"], // One story house 
        ["D1", "D102"], // Post1980
        ["B2", "B203"], // Masonry 
        ["C1", "C102"], // Casement (w/ locks)
        ["C2", "C206"], // Other
        ["D2", "D204"], // Roof is 10-20 years old
        ["D3", "D302"], // Hip Roof
        ["D4", "D402"], // Tile Roof
        ["D5", "D502"], // No Sarking
        //["D6", "D603"],
        //["D7", "D702"],
        ["D8", "D802"], // Yes ridgecap upgrade w/in last 5 yrs
        ["C3", "C301"], // Nope (Garage door)
        ["A1", "A106"], // Secure outdoor; prep kit
        ["A2", "A205"], // Cyclone kit and anchored to slab (or cyclone rated from day 1)
        ["E1", "E102"], // Cyclone Talk Often - Slightly Agree (SLA)
        ["E2", "E201"], // Shutters Reduce Damage - SA
        ["E3", "E304"], // Shutters Other Benefit - SLD
        ["E4", "E403"], // Shutters Expensive - N
        ["E5", "E503"], // Cyclone Experience - Yasi
        ["E6", "E601"], // Same Location Now - Yes
        ["E7", "E701"], // What Category of Wind Speed - 1 
        ["E8", "E802"], // Expected Cat 5 Damage - Minor
        ["E9", "E901"], // Cat 5 Likelihood - <20%
      ]
    },
    { which: 2,
      valueSet: [
        ["B1", "B102"], // Elevated one story house
        ["D1", "D102"], // Post1980
        ["B2", "B202"], // Timber / weatherboard
        ["C1", "C103"], // Casement (w/o locks)
        ["C2", "C201"], // No Protection
        ["D2", "D204"], // Roof is 10-20 years old
        ["D3", "D303"], // Complex
        ["D4", "D401"], // Metal Roof
        ["D5", "D501"], // Sarking
        ["D6", "D603"], // Clips
        ["D7", "D702"], // Yes roof overbatten
        ["D8", "D802"], // Yes ridgecap upgrade w/in last 5 yrs
        ["C3", "C304"], // Garage Door (<2012, w/ purchased brace)
        ["A1", "A107"], // Clean yard; prep kit
        ["A2", "A205"], // Cyclone kit and anchored to slab (or cyclone rated from day 1)
        ["E1", "E101"], // Cyclone Talk Often - Strongly Agree (SA)
        ["E2", "E202"], // Shutters Reduce Damage - SLA
        ["E3", "E303"], // Shutters Other Benefit - N
        ["E4", "E404"], // Shutters Expensive - SLD
        ["E5", "E501"], // Cyclone Experience - Debbie
        ["E6", "E602"], // Same Location Now - No
        ["E7", "E703"], // What Category of Wind Speed - 3 
        ["E8", "E802"], // Expected Cat 5 Damage - Minor
        ["E9", "E903"], // Cat 5 Likelihood - 40-60%
      ]
    }
  ],
  getValuePairSet: function(which) {
    let vps = this.valuePairSets.find(p => p.which == which)
    return vps ? vps.valueSet : []
  }

}
//export { testSets }
module.exports = testSets

